/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AlertNotificationDetailsModel {
    getFixupPrototypeFunction() { return AlertNotificationDetailsModel.fixupPrototype; }

    static newInstance(model: Partial<AlertNotificationDetailsModel>): AlertNotificationDetailsModel {
        let obj = Object.assign(new AlertNotificationDetailsModel(), model);
        AlertNotificationDetailsModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AlertNotificationDetailsModel>): AlertNotificationDetailsModel {
        if (!model) return null;
        return AlertNotificationDetailsModel.newInstance(<AlertNotificationDetailsModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AlertNotificationDetailsModel) {
        if (!obj) return;

        models.AlertNotificationDetailsModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AlertNotificationDetailsModel): boolean {
        Object.setPrototypeOf(obj, AlertNotificationDetailsModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.notification_details) {
            for (let val of this.notification_details) {
                models.NotificationDetailsModel.fixupPrototype(val);
            }
        }
    }

    /**
     * notification name
     */
    name: string;

    /**
     * notification name
     */
    notification_uri: string;

    /**
     * notification name
     */
    is_template: boolean;

    /**
     * Notification Details
     */
    notification_details: Array<models.NotificationDetailsModel>;

}
